import Home from '../../Home';
import Addresses from '../../Addresses';
import ViewAddress from '../../Addresses/View';
import Profile from '../../User/Profile';
import UserOverview from '../../User/Overview';
import ChildUserForm from '../../User/ChildUserForm';
import Messages from '../../Messages';
import MessagesOverview from '../../Messages/Overview';
import ViewMessage from '../../Messages/View';
import ReportGenerator from '../../Reports/Generator';
import ChooseClient from '../ChooseClient';
import Logout from '../../User/Logout';
import PasswordReset from '../../User/PasswordReset';
import Content from '../../Content';
import RedirectToDPS from '../RedirectToDPS';

const ComponentDictionary = {
    Home : Home,
    Addresses : Addresses,
    ViewAddress : ViewAddress,
    Profile : Profile,
    UserOverview : UserOverview,
    ChildUserForm : ChildUserForm,
    Messages : Messages,
    MessagesOverview : MessagesOverview,
    ViewMessage : ViewMessage,
    ReportGenerator: ReportGenerator,
    ChooseClient: ChooseClient,
    Logout : Logout,
    PasswordReset: PasswordReset,
    Content: Content,
    RedirectToDPS: RedirectToDPS
};

export default ComponentDictionary;


// WEBPACK FOOTER //
// ./src/components/Application/ComponentDictionary/index.js